<cmi-back-button />

<div class="space-y-4">
  <div class="flex justify-end">
    <a
      routerLink="/tenants/add"
      class="px-4 py-2 text-sm text-main font-medium rounded-lg border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors flex items-center">
      <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      {{ 'tenantList.addTenant' | translate }}
    </a>
  </div>

  @if (tenantService.tenants().length === 0) {
    <div class="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
      <div class="text-gray-400 mb-2">
        <svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <p class="text-gray-600 font-medium mb-1">
        {{ 'tenantList.noTenantsFound' | translate }}
      </p>
      <p class="text-gray-500 text-sm">{{ 'tenantList.noTenantsHint' | translate }}</p>
      <p class="text-blue-600 text-sm">
        <a href="https://dokumentation.cmiag.ch/cmi-vorlagen" target="_blank" class="underline">
          {{ 'tenantList.documentationLink' | translate }}</a
        >
      </p>
    </div>
  } @else {
    <div class="space-y-2">
      @for (tenant of tenantService.tenants(); track tenant.name) {
        <div
          (click)="selectTenant(tenant.name)"
          [class]="
            'w-full p-3 rounded-lg border-2 transition-colors cursor-pointer ' +
            (tenantService.selectedTenantName() === tenant.name
              ? 'border-main bg-main/5'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50')
          "
          [title]="'tenantList.selectTenantTitle' | translate">
          <div class="flex justify-between items-center">
            <div class="flex-1 min-w-0">
              <span
                [class]="
                  'text-base ' +
                  (tenantService.selectedTenantName() === tenant.name
                    ? 'font-medium text-gray-900'
                    : 'text-gray-700')
                ">
                {{ tenant.name }}
              </span>
            </div>
            @if (deletingTenantId() === tenant.name) {
              <div class="flex items-center gap-2 ml-4">
                <span class="text-sm text-gray-600">{{
                  'tenantList.deleteConfirm' | translate
                }}</span>
                <button
                  (click)="deleteTenant(tenant.name); $event.stopPropagation()"
                  class="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  type="button"
                  [title]="'tenantList.deleteConfirmTitle' | translate">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 13l4 4L19 7" />
                  </svg>
                </button>
                <button
                  (click)="cancelDelete(); $event.stopPropagation()"
                  class="p-1.5 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                  type="button"
                  [title]="'tenantList.cancelTitle' | translate">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            } @else {
              <div class="flex gap-1 ml-4">
                <a
                  (click)="$event.stopPropagation()"
                  [routerLink]="['/tenants/edit', tenant.name]"
                  class="p-1.5 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                  [title]="'tenantList.editTenantTitle' | translate">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </a>
                <button
                  (click)="confirmDelete(tenant.name); $event.stopPropagation()"
                  class="p-1.5 text-gray-600 hover:text-red-600 hover:bg-gray-100 rounded-lg transition-colors"
                  type="button"
                  [title]="'tenantList.deleteTenantTitle' | translate">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <div class="mt-4 flex gap-4">
    <input
      type="file"
      id="file-input"
      accept="application/json"
      (change)="onFileSelected($event)"
      class="hidden" />

    <button
      (click)="triggerFileInput()"
      [disabled]="isImporting()"
      class="px-4 py-2 text-sm text-main font-medium rounded-lg border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:border-gray-100"
      type="button">
      @if (isImporting()) {
        <svg
          class="animate-spin h-4 w-4 mr-1.5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4" />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      } @else {
        <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
        </svg>
      }
      {{ 'tenantList.import' | translate }}
    </button>

    <button
      (click)="exportTenants()"
      [disabled]="isExporting() || tenantService.tenants().length === 0"
      class="px-4 py-2 text-sm text-main font-medium rounded-lg border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:border-gray-100"
      type="button">
      @if (isExporting()) {
        <svg
          class="animate-spin h-4 w-4 mr-1.5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4" />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      } @else {
        <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
        </svg>
      }
      {{ 'tenantList.export' | translate }}
    </button>
  </div>

  @if (importError()) {
    <div class="mt-2 text-sm text-red-600">{{ importError() }}</div>
  }
</div>
